<template>
    <div class="uk-padding">
        <div class="uk-container">
            <h1 class="uk-text-center ">
                <span class="half-a-border-on-top">NCU's Sub Division</span>
            </h1>
            <div class="uk-child-width-1-5@m uk-flex uk-flex-center" uk-grid>
                <div class="uk-padding-small">
                    <img src="/butterfly.jpg" alt="Avatar" style="margin-bottom: 10px">
                    <span class="uk-text-center " >NCU Early Childhood</span>
                </div>
                <div class="uk-padding-small"><img src="/butterfly.jpg" alt="Avatar" style="margin-bottom: 10px">
                    <span class="uk-text-center " >NCU Day Care</span>
                </div>
                <div class="uk-padding-small">
                    <img src="/butterfly.jpg" alt="Avatar" style="margin-bottom: 10px">
                    <span class="uk-text-center " >Thai Center</span>
                </div>
                <div class="uk-padding-small">
                    <img src="/butterfly.jpg" alt="Avatar" style="margin-bottom: 10px">
                    <span class="uk-text-center " >University Press</span>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ncuImpact"
    }
</script>

<style scoped>
    img{
        border-radius: 50%;
    }
    h1{
        color: #033860;
    }
    .half-a-border-on-top {
        border-top: 2px solid gold;
        position: relative;
        color: #033860 ;

    }
    .half-a-border-on-top:after {
        padding-top: 10px;
        content: "";
        width:50%;
        height: 3px;/* slight higher to work around rounding errors(?) on some zoom levels in some browsers. */
        background-color: white;
        position: absolute;
        right:0;
        top:-2px;
    }
</style>